import marketReports from './market-reports';
import researchLibrary from './research-library';
import customExports from './custom-exports';
import customReports from './custom-reports';
import kpiForecasts from './kpi-forecasts';

export default {
  marketReports,
  customExports,
  researchLibrary,
  customReports,
  kpiForecasts,
};
